  @if(isLoading) {
    <div class="page-loader"></div>
  }
<div class="modal-header">
    <h4 class="modal-title">{{commentModel?.note ? 'Edit' : 'Add'}} {{ !addCommentStockAllocation ? 'Internal' : '' }} Note</h4>
</div>
<div class="modal-body">
    <p class="body-text">
        These notes are not visible to the customer. Use this text box to detail important information relevant to this
        record.
    </p>
    <div class="add-comment-box" id="editor-container" #editorContainer></div>
    <span *ngIf="(submitted && !comment) || isQuillEmptyError">
        <span class="error-message">Enter the note.</span>
    </span>
</div>
<div class="modal-footer">
    <button type="button" class="dark-bordered-btn" data-dismiss="modal" (click)="ngbActiveModal.close()">Cancel</button>
    <button class="submit-btn-grey" type="submit" (click)="submit()">{{commentModel?.note ? 'Edit' : 'Add'}} Note</button>
</div>
